import { useState, useEffect } from "react";
import { Button, Card, CardActions, CardContent, Grid, Stack } from "@mui/material";
import { FieldTextField } from "../../../components/selections/fieldInputs";
import CampaignIcon from '@mui/icons-material/Campaign';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { StepHeader, stepCardSx, stepActionsSx, backBtnSx, nextBtnSx } from "./stepUi";
import { useSelector, useDispatch } from "react-redux";
import { setActiveNext, setActiveBack, setCampaignTitle } from "../campaignSlice";
import SnackbarMessage from "../../../components/snackBar/snackBar";


export default function CampaignTitle() {
    const dispatch = useDispatch();
    const { activeStep, campaign_Title } = useSelector((state) => state.campaigns);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const [state, setState] = useState({
        campaignTitle: "",
        errors: {}
    });

    const { campaignTitle, errors } = state;

    const handleBack = () => {
        dispatch(setActiveBack());
    };



    const campaignFields = [
        { id: 1, name: "campaignTitle", value: campaignTitle, label: "Campaign Name" },
    ];

    const validateStep = () => {
        const validations = [
            { valid: !!campaignTitle, message: "Campaign Title is required", field: "campaignTitle" },
        ];

        const newErrors = {};
        let isValid = true;

        for (let rule of validations) {
            if (!rule.valid) {
                setSnackbar((prev) => ({
                    ...prev,
                    open: true,
                    message: rule.message,
                    severity: "error",
                }));

                setState((prev) => ({
                    ...prev,
                    errors: { ...prev.errors, [rule.field]: rule.message },
                }));

                isValid = false;
                return;
            }
        }

        setState((prev) => ({ ...prev, errors: { ...prev.errors, ...newErrors } }));

        return isValid;
    };

    const handleNext = () => {
        if (activeStep === 0) {
            if (!validateStep()) return;
            dispatch(setCampaignTitle({
                campaignTitle: campaignTitle,
            }))
        }
        dispatch(setActiveNext());
    };

    useEffect(() => {
        if (campaign_Title) {
            setState(prev => ({
                ...prev,
                campaignTitle: campaign_Title,
            }));
        }
    }, [campaign_Title]);


    return (
        <div>
            <Card sx={stepCardSx}>
                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                    <StepHeader icon={<EditNoteIcon sx={{ fontSize: 20 }} />} title="Campaign Details" subtitle="Give your campaign a clear name so you can find it later" />
                    <Grid container spacing={2}>
                        {
                            campaignFields.map((field, inex) => (
                                <Grid item size={{ xs: 12, md: 6 }} key={field.id}>
                                    <FieldTextField
                                        name={field.name}
                                        label={field.label}
                                        required
                                        icon={<CampaignIcon />}
                                        placeholder="e.g. Diwali_Offer_2026"
                                        value={field.value}
                                        error={!!errors[field.name]}
                                        onChange={(e) =>
                                            setState((prev) => ({
                                                ...prev,
                                                [field.name]: e.target.value,
                                                errors: { ...prev.errors, [e.target.name]: "" },
                                            }))
                                        }
                                        maxLength={80}
                                        onKeyDown={(e) => {
                                            if (e.key === " " || e.key === "Spacebar") {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                </CardContent>

                <CardActions sx={stepActionsSx}>
                    <Stack direction="row" spacing={1.5}>
                        <div style={{ cursor: activeStep === 0 ? "not-allowed" : "pointer" }}>
                            <Button disabled={activeStep === 0} variant="outlined" onClick={handleBack} sx={backBtnSx}>
                                Back
                            </Button>
                        </div>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                            disabled={activeStep >= 2}
                            sx={nextBtnSx}
                        >
                            Next
                        </Button>
                    </Stack>
                </CardActions>
            </Card>

            <SnackbarMessage open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} />
        </div>
    );
}
